var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:max-line-length
// This file is generated by generateStyles script.
// Please don't edit it manually.
import * as React from "react";
import "../../less/svg/ArrowNarrow.less";
export var ArrowNarrow = function (props) { return (React.createElement("svg", { viewBox: "0 0 32.23 22.56" },
    React.createElement("defs", null),
    React.createElement("g", __assign({ id: "Layer_2" }, props, { className: "ArrowNarrow " + props.className }),
        React.createElement("g", { id: "Quick_sell", "data-name": "Quick sell" },
            React.createElement("path", { id: "ArrowNarrow", className: "cls-1", d: "M32.23 11.28L21 0v8.47H2.81a2.81 2.81 0 0 0 0 5.62H21v8.47z" }))))); };



//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ArrowNarrow.tsx
// module id = 872
// module chunks = 3